// Hình thức hóa đơn
export default {
    SeftPrintInvoice: 0,
    OrderPrintInvoice: 1,
    ElectronicInvoice: 2,
};